import useSWR from 'swr';

import myShopClient from '@services/nearlive';

/**
 * KPI summary for a shop's orders. Wraps `GET /api/orders/insights/{shopId}`
 * (Unify-specific handler — see `get-order-insights-unify.js`), which returns
 * `{ ordersPlaced, reservationsPlaced, totalOrderValue }`. `totalOrderValue`
 * is a pre-formatted currency string from the Lambda — it already excludes
 * `cancelled` / `refunded` orders and multiplies by quantity so the front-end
 * reads it through verbatim.
 *
 * Bypasses `@services/orders` for the same reason as `useOrders`: avoids the
 * `@nearst/ui` global-SCSS leak via `ShopProvider`.
 */
export function useOrderInsights(shopId, { from, to, currency } = {}) {
	const key = shopId ? ['unify:order-insights', shopId, from, to, currency] : null;
	const { data, error, isLoading, mutate } = useSWR(
		key,
		async () => {
			const client = await myShopClient();
			const { data } = await client.get(`/api/orders/insights/${shopId}`, {
				params: { start: from, end: to, currency }
			});
			return data;
		},
		{ revalidateOnFocus: false, refreshInterval: 60_000 }
	);
	return { insights: data || null, error, isLoading, mutate };
}
